/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AutoTestStepLogBase } from './AutoTestStepLogBase';
const RunProgramLogParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['stdout', codecString],
    ['stderr', codecString],
    ['exitCode', codecNumber, 'exit_code'],
    ['timeSpend', parsers.duration, 'time_spend'],
]), AutoTestStepLogBase);
export class RunProgramLog extends AutoTestStepLogBase {
    static decode(input) {
        return RunProgramLogParser.decode(input).map(res => new RunProgramLog(res));
    }
    static unsafeDecode(input) {
        return RunProgramLog.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RunProgramLogParser.encode(data);
    }
    static schema() {
        return RunProgramLogParser.schema();
    }
}
